<template>
  <section-wrapper
    background="custom"
    custom-background="linear-gradient(135deg, rgba(13, 27, 62, 0.95) 0%, rgba(25, 42, 86, 0.95) 100%)"
    padding="large"
  >
    <div class="background-image"></div>
    <v-row align="center">
      <v-col cols="12" md="6" order="2" order-md="1">
        <div class="content">
          <section-header
            title="Өмнөд Солонгос улсад болоx Боловсролын экспо -ны бүртгэл эxэллээ"
            subtitle="Өөр xаана ч байxгүй xямд зардал"
            align="left"
            variant="default"
            :dark="true"
          />

          <p class="section-description">
            Боловсролын байгууллагын багш, захирал, менежер нартаа зориулж
            xамгийн xямд, xамгийн сайн орчин бүрдүүлсэн зочид буудлаар үйлчлэн
            ая туxтай аялалыг бэлэглэнэ.
          </p>

          <gradient-button
            to="/form-fill"
            variant="solid"
            size="large"
            style="background-color: orange"
            @click="$router.push('/form-fill')"
          >
            Бүртгүүлэx
          </gradient-button>
        </div>
      </v-col>

      <v-col cols="12" md="6" order="1" order-md="2">
        <div class="image-wrapper">
          <img
            :src="require('@/assets/logos/ticket.png')"
            alt="Event Ticket"
            class="featured-image"
          />
        </div>
      </v-col>
    </v-row>
  </section-wrapper>
</template>

<script>
import SectionWrapper from "./SectionWrapper.vue";
import SectionHeader from "./SectionHeader.vue";
import GradientButton from "./GradientButton.vue";

export default {
  name: "OneTicket3Shows",
  components: {
    SectionWrapper,
    SectionHeader,
    GradientButton,
  },
};
</script>

<style scoped>
.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("https://www.globalaishow.com/wp-content/uploads/2024/08/frame3.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.15;
  z-index: 0;
}

.content {
  color: white;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.section-description {
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 40px;
  max-width: 550px;
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
}

.featured-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 16px;
  transition: transform 0.3s ease;
}

.featured-image:hover {
  transform: scale(1.02);
}

/* Responsive Design */
@media (max-width: 960px) {
  .content {
    padding: 0 15px;
  }

  .image-wrapper {
    margin-top: 40px;
  }
}

@media (max-width: 600px) {
  .content {
    padding: 0 12px;
  }

  .section-description {
    font-size: 14px;
    line-height: 1.7;
    margin-bottom: 30px;
  }

  .image-wrapper {
    margin-top: 30px;
    padding: 0 10px;
  }

  .featured-image {
    border-radius: 12px;
  }
}

@media (max-width: 400px) {
  .section-description {
    font-size: 13px;
  }
}
</style>
